import queryString from "query-string";
export const setOfferUrl = function (productCode, offerId) {
  let parsedUrl = queryString.parseUrl(location.href, {
    parseFragmentIdentifier: true,
  });
  parsedUrl["query"]["offer"] = offerId;

  let newUrl = queryString.stringifyUrl(parsedUrl);
  newUrl = newUrl.replace(/(\/product\/).*(\/)/, "$1" + productCode + "$2");

  history.pushState(null, null, newUrl);
};
